export class HighlighterValueConverter {
	toView(value, highlightedText) {
		if (highlightedText == undefined || highlightedText === '') {
			return value;
		}
		return value.toString().replace(new RegExp(highlightedText, 'gi'), '<span class="highlight">$&</span>');
	}
}
